var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 656,
    height: 656,
    viewBox: "0 0 656 656",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_666_20)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.382 133.039C417.035 99.0929 375.732 81.9199 327.469 81.9199C279.217 81.9199 237.931 99.0971 203.985 133.039C169.622 166.98 152.466 208.271 152.865 256.939C152.865 289.235 160.635 318.279 175.774 344.443C176.591 345.668 177.808 347.31 179.042 349.357L324.201 573.44L478.375 346.485C494.314 319.913 502.501 290.068 502.501 256.939C502.501 208.271 485.311 166.985 451.382 133.039Z",
    fill: "#333ADB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.478 178.423C304.169 178.001 284.528 186.196 268.172 202.969C251.816 219.317 243.647 238.949 243.647 262.258C243.647 285.558 251.816 305.191 268.172 321.964C284.532 338.315 304.169 346.489 327.478 346.489C350.774 346.485 370.411 338.32 387.171 321.964C403.527 305.191 411.714 285.567 411.714 262.258C411.714 238.949 403.527 219.326 387.171 202.969C370.415 186.192 350.774 178.006 327.478 178.423Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_666_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 655.359,
    height: 655.359,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.90d0cb464917c74801b4a1df45ea96b7.svg";
export { ForwardRef as ReactComponent };